import { Button, ConfirmAlert, Modal, TextSubHeader } from '@carboncopyco/ui';
import { type ReactNode, useState } from 'react';

export type VerticalTabsModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  confirmOnCancel?: boolean;
  onSave: () => void;
  isSaveDisabled?: boolean;
  footerLeftContent?: ReactNode;
  children: ReactNode;
};

export const VerticalTabsModal = ({
  open,
  onClose,
  title,
  confirmOnCancel,
  onSave,
  isSaveDisabled,
  footerLeftContent,
  children,
}: VerticalTabsModalProps) => {
  const [isModalAlertOpen, setIsModalAlertOpen] = useState(false);
  const handleClose = () => {
    if (confirmOnCancel) {
      setIsModalAlertOpen(true);
    } else {
      onClose();
    }
  };

  return (
    <>
      <Modal
        noPadding
        onClose={handleClose}
        containerClass="w-[812px] flex flex-col"
        open={open}
        title={
          <div className="flex justify-between p-5">
            <TextSubHeader
              label={title}
              color="text-ds-natural-600"
            />
          </div>
        }
        locked
        closeOnlyFromCloseIcon
      >
        <div className="flex flex-col border-t border-t-ds-natural-150">
          <div className="flex h-[552px] grow shrink min-w-0">
            <div className="flex grow min-w-0">{children}</div>
          </div>
          <div className="flex flex-col border-t border-t-ds-natural-150">
            <div className="flex justify-end p-5 gap-4">
              {footerLeftContent && (
                <div className="pt-0.5 me-auto">{footerLeftContent}</div>
              )}
              <div className="flex gap-4">
                <Button
                  label="Cancel"
                  linkLight
                  onClick={handleClose}
                />
                <Button
                  label="Save"
                  disabled={isSaveDisabled}
                  onClick={onSave}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {confirmOnCancel && (
        <ConfirmAlert
          danger
          show={isModalAlertOpen}
          title="Cancel changes"
          description="By clicking on “cancel changes” no changes will be saved."
          yesLabel="Cancel changes"
          noLabel="Exit"
          onConfirm={onClose}
          onClose={() => setIsModalAlertOpen(false)}
        />
      )}
    </>
  );
};
